/* eslint-disable import/prefer-default-export */
const Category = Object.freeze({
    DEALS: 'Deals',
    SERVICE: 'Service',
    PARTS: 'Parts',
    CRM: 'CRM',
    INVENTORY: 'Inventory',
    ELECTRONIC_PAYMENT: 'ElectronicPayment',
    SMS: 'SMS',
    MANHEIM: 'Manheim',
});

export const CompanySettingkey = Object.freeze({
    ALLOW_ONLY_VEHICLES_IN_USER_AVAILABLE_LOTS: 'allowOnlyVehiclesInUserAvailableLots',
    SEND_EMAIL_RECEIPTS_FOR_EXTERNAL_ELECTRONIC_PAYMENTS: 'SendEmailReceiptsforExternalElectronicPayments',
    SEND_EMAIL_RECEIPTS_FOR_AUTO_PAYMENTS: 'SendEmailReceiptsforAutoPayments',
    PARTS_CLERK_GLOBAL_ROLE: 'partsClerkGlobalRole',
    ASSIGNEE_GLOBAL_ROLE: 'assigneeGlobalRole',
    TECHNICIAN_GLOBAL_ROLE: 'technicianGlobalRole',
    PROVIDER: 'Provider',
    MMS_ENABLED: 'MMS_Enabled',
    MANHEIM_CLIENT_ID: 'ClientId',
    MANHEIM_DEFAULT_LOT: 'Lot',
    MANHEIM_USER_IMPORT: 'UserImport',
    MANHEIM_SELLER_CUSTOM_FIELD: 'SellerCustomField',
    MANHEIM_LOCATION_STATUS_CUSTOM_FIELD: 'LocationStatusCustomField',
});

export default Category;
